// Pantalla TFT a color ILI9341 de 2.8″ (240×320, SPI).
import { definePart, PITCH } from './registry.js';

export const TFT = { w: 86, d: 50, pcbY: 3, t: 1.6, panel: [70.2, 50.6], active: [57.6, 43.2], panelX: -5 };

definePart({
  type: 'tft-ili9341',
  name: 'Pantalla TFT ILI9341 2.8″',
  category: 'luces',
  description: 'Pantalla a color de 240×320 por SPI (librerías Adafruit_ILI9341 y Adafruit_GFX): gráficos, texto y colores de 16 bits.',
  keywords: 'tft lcd color ili9341 2.8 spi grafica adafruit gfx pantalla',
  pins: ['VCC', 'GND', 'CS', 'RST', 'DC', 'MOSI', 'SCK', 'LED', 'MISO'].map((name, i) => ({
    name,
    label: { VCC: 'VCC (5 V / 3.3 V)', GND: 'GND', CS: 'CS (selección SPI)', RST: 'RESET', DC: 'D/C (dato o comando)', MOSI: 'SDI (MOSI)', SCK: 'SCK', LED: 'LED (luz de fondo)', MISO: 'SDO (MISO)' }[name],
    kind: name === 'GND' ? 'gnd' : name === 'VCC' || name === 'LED' ? 'power' : 'signal',
    x: TFT.w / 2 - 3,
    y: TFT.pcbY + TFT.t + 8.6,
    z: (i - 4) * PITCH,
  })),
  footprint: { w: TFT.w + 1, d: TFT.d + 1, h: 10 },
  help: 'Conexión al Uno: CS → 10, DC → 9, RST → 8, MOSI → 11, SCK → 13, MISO → 12, LED y VCC a 5 V, GND a GND. Con <code>Adafruit_ILI9341 tft(10, 9, 8)</code>.',
});
